<div [ngClass]="isLightMode ? 'tech-bg text-slate-900' : 'tech-bg dark text-white'" class="h-screen overflow-hidden flex flex-col relative transition-colors duration-500">

  <!-- Fixed Navbar — transparent over tech-bg, glass on scroll -->
  <nav class="fixed top-0 left-0 right-0 z-50 py-3 transition-all duration-300 border-b border-white/10"
       [ngClass]="scrolled
         ? (isLightMode ? 'bg-white/95 backdrop-blur-md shadow-lg border-white/20' : 'bg-gray-900/90 backdrop-blur-md shadow-lg border-gray-800')
         : 'bg-transparent border-transparent'"   aria-label="Main Navigation">
    <div class="!max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full">
      <div class="flex items-center justify-between h-full">
        <!-- Logo -->
       <div class="flex items-center gap-2">
        <div
          class="bg-secondary/50 p-2 rounded-xl text-white shadow-lg flex items-center justify-center"
        >
          <div class="w-1.5 h-5 bg-[#1eb052] rounded-full"></div>
          <div
            class="w-1.5 h-6 bg-[#fcd116] rounded-full [animation-delay:0.15s]"
          ></div>
          <div
            class="w-1.5 h-5 bg-black rounded-full [animation-delay:0.3s]"
          ></div>
          <div
            class="w-1.5 h-6 bg-[#00a3e0] rounded-full [animation-delay:0.45s]"
          ></div>
        </div>
        <span
          class="text-2xl font-bold tracking-tight"
          [ngClass]="scrolled ? (isLightMode ? 'text-primary' : 'text-white') : 'text-white'"
          >GISP</span>
      </div>

        <!-- Nav Links -->
        <div class="hidden md:block">
          <div class="ml-10 flex items-center space-x-8">
            <a [routerLink]="['/']" fragment="services"
              class="font-semibold transition-colors cursor-pointer text-sm text-white hover:text-teal-200 relative group py-2">
              Services
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-white/60 transition-all group-hover:w-full"></span>
            </a>
            <a [routerLink]="['/']" fragment="how-do-i"
              class="font-semibold transition-colors cursor-pointer text-sm text-white hover:text-teal-200 relative group py-2">
              How Do I
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-white/60 transition-all group-hover:w-full"></span>
            </a>

            <!-- Theme Switcher -->
            <label class="switch scale-90">
              <span *ngIf="!isLightMode" class="sun">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="#C99900"><circle cx="12" cy="12" r="5"></circle><path d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"></path></g></svg>
              </span>
              <span *ngIf="isLightMode" class="moon">
                <svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg"><path d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"></path></svg>
              </span>
              <input (ngModelChange)="toggleTheme()" [(ngModel)]="isLightMode" class="input" type="checkbox" />
              <span class="slider"></span>
            </label>

            <button [routerLink]="['/']" class="ml-4 flex items-center justify-center gap-2 px-5 py-2 rounded-full text-sm font-bold transition-all transform hover:-translate-y-0.5 border border-white/40 text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm shadow-lg">
              <mat-icon class="p-0 m-0 text-[18px]">store</mat-icon>
              <span>Welcome Portal</span>
            </button>
          </div>
        </div>

      </div>

    </div>
  </nav>

  <!-- Animated blobs over tech-bg -->
  <div class="absolute inset-0 overflow-hidden pointer-events-none z-0">
    <div class="absolute -top-[20%] -left-[10%] w-[60%] h-[60%] bg-white/10 rounded-full blur-[120px] animate-blob"></div>
    <div class="absolute top-[20%] -right-[10%] w-[50%] h-[70%] bg-teal-300/20 rounded-full blur-[120px] animate-blob animation-delay-2000"></div>
    <div class="absolute -bottom-[20%] left-[20%] w-[60%] h-[60%] bg-sky-300/20 rounded-full blur-[120px] animate-blob animation-delay-4000"></div>
  </div>
  <!-- Tech grid lines overlay (from guest-main-copy .tech-lines) -->
  <div class="tech-lines absolute inset-0 pointer-events-none z-[1]"></div>

  <!-- Main Content Body (scrollable center, accounts for fixed nav with pt-24) -->
  <main id="main-content" class="flex-1 overflow-y-auto relative flex flex-col pt-24">

    <!-- Layout Grid Container -->
    <div class="!max-w-7xl mx-auto w-full relative z-[10] flex-1 flex flex-col justify-center px-4 sm:px-6 lg:px-8 pb-12">
      <div class="grid lg:grid-cols-2 gap-12 items-center py-8">

        <!-- LEFT TEXT SLIDER — hidden on mobile -->
        <div class="hidden lg:flex flex-col justify-center text-center lg:text-left">
          <ng-container *ngFor="let slide of slides; let i = index">
            <div *ngIf="i === index"
                 class="absolute left-0 xl:-left-4 w-full max-w-[380px] xl:max-w-[420px] aspect-[1/1] animate-fadeIn peer cursor-pointer z-0 shadow-2xl rounded-[24px]">
              <div class="slider-image-mask w-full h-full rounded-[24px] overflow-hidden bg-black/10">
                <!-- <img [src]="slide.image" class="w-full h-full object-cover transition-transform duration-700" alt="Slide image" /> -->
              </div>
            </div>
          </ng-container>

          <!-- Text content -->
          <div class="relative z-10 ml-auto w-[85%] xl:w-[80%] flex flex-col justify-center text-center lg:text-left transition-all duration-700 h-full pointer-events-none">
            <ng-container *ngFor="let slide of slides; let i = index">
              <div *ngIf="i === index" class="animate-fadeIn pointer-events-auto">
                <div class="text-3xl xl:text-4xl font-black tracking-tight leading-tight mb-3">
                <span class="block drop-shadow-lg opacity-80" [ngClass]="isLightMode ? 'text-teal-200' : 'text-white'">{{ slide.subtitle }}</span>
                <span class="block drop-shadow-lg opacity-80" [ngClass]="isLightMode ? 'text-teal-200' : 'text-white'">{{ slide.title }}</span>
              </div>
              <p class="text-lg xl:text-base opacity-90 leading-relaxed max-w-md font-light mb-8" [ngClass]="isLightMode ? 'text-teal-50' : 'text-white/80'">
                {{ slide.desc }}
              </p>
            </div>
          </ng-container>

      <!-- Stats -->
      <div class="flex  gap-8 mb-8" [ngClass]="isLightMode ? 'text-slate-700' : 'text-white'">
        <div class="flex flex-col gap-0.5">
          <span class="text-2xl text-teal-200 font-bold">24/7</span>
          <span class="text-[10px] uppercase text-white opacity-90 tracking-[0.18em] font-bold" [ngClass]="isLightMode ? 'text-white' : 'text-white/50'">Technical Support</span>
        </div>
        <div class="w-px h-10" [ngClass]="isLightMode ? 'bg-slate-300' : 'bg-white/15'"></div>
        <div class="flex flex-col gap-0.5">
          <span class="text-2xl text-teal-200 font-bold">99.9%</span>
          <span class="text-[10px] uppercase text-white opacity-90 tracking-[0.18em] font-bold" [ngClass]="isLightMode ? 'text-white' : 'text-white/50'">Server Uptime</span>
        </div>
        <div class="w-px h-10" [ngClass]="isLightMode ? 'bg-slate-300' : 'bg-white/15'"></div>
        <div class="flex flex-col gap-0.5">
          <span class="text-2xl text-teal-200 font-bold">50+</span>
          <span class="text-[10px] uppercase text-white opacity-90 tracking-[0.18em] font-bold" [ngClass]="isLightMode ? 'text-white' : 'text-white/50'">ICT Services</span>
        </div>
      </div>

      <!-- Slide indicators + nav -->
      <div class="flex gap-4 pointer-events-auto">
        <button (click)="prevSlide()" class="w-8 h-8 rounded-full border flex items-center justify-center transition-all backdrop-blur-sm"
          [ngClass]="isLightMode ? 'bg-slate-200/50 hover:bg-slate-300/50 border-slate-300 text-slate-700' : 'bg-white/15 hover:bg-white/30 border-white/20 text-white'"
          aria-label="Previous">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <div class="flex items-center gap-2">
              <div *ngFor="let s of slides; let i = index"
                (click)="this.index = i"
                class="cursor-pointer rounded-full transition-all duration-500"
                [ngClass]="i === index ? 'w-8 h-2.5 bg-primary-600 dark:bg-primary-400 shadow-sm shadow-primary-500/30' : 'w-2.5 h-2.5 bg-slate-300 dark:bg-gray-600 hover:bg-slate-400 dark:hover:bg-gray-500'">
              </div>
            </div>
            <button (click)="nextSlide()" class="w-10 h-10 rounded-full border border-slate-200 dark:border-gray-700 flex items-center justify-center transition-all bg-white/50 dark:bg-gray-800/50 hover:bg-slate-100 dark:hover:bg-gray-700 text-slate-700 dark:text-gray-300 backdrop-blur-sm shadow-sm hover:scale-105" aria-label="Next">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
        </div>
        </div>

        <!-- RIGHT LOGIN FORM -->
        <div class="flex items-center justify-center lg:justify-end relative">

          <div class="w-full max-w-[420px] relative group">

            <!-- Card Glow Overlay linked to the animated blobs ("Globe") -->
            <div class="absolute -inset-2 bg-gradient-to-r from-primary-600/20 to-secondary/30 rounded-[28px] blur-xl opacity-30 group-hover:opacity-60 transition duration-1000 group-hover:duration-500"></div>

            <!-- Card -->
            <div class="relative glass-crystal-card rounded-[24px] p-8 md:p-10 transition-all duration-500 group-hover:shadow-2xl overflow-hidden"
                 [ngClass]="isLightMode ? 'bg-white/90 border-white/60' : 'bg-gray-900/60 border-gray-800'">

              <!-- Inner top light line -->
              <div class="absolute top-0 left-0 w-full h-px" [ngClass]="isLightMode ? 'bg-gradient-to-r from-transparent via-primary/20 to-transparent' : 'bg-gradient-to-r from-transparent via-white/20 to-transparent'"></div>

              <!-- ======= STEP 1: Credentials ======= -->
              <div *ngIf="loginStep === 'credentials'" class="animate-fadeIn">

                <!-- Timeout Error -->
                <div *ngIf="isTimeout" class="mb-5 flex items-center gap-2 p-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-600 dark:text-red-400 text-xs font-semibold">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  <span>{{ timeoutMessage }}</span>
                </div>

                <!-- Card Header -->
                <div class="mb-8 flex flex-col md:flex-row items-center md:items-start gap-4 text-center md:text-left">
                  <div class="w-14 h-14 bg-gradient-to-br from-primary-50 to-white dark:from-gray-800 dark:to-gray-700 rounded-xl flex items-center justify-center border border-primary-100 dark:border-gray-600 shadow-sm">
                    <img src="assets/images/emblem.png" class="w-8 h-8" alt="Emblem">
                  </div>
                  <div class="mt-1">
                    <div class="text-2xl font-bold tracking-tight" [ngClass]="isLightMode ? 'text-slate-900' : 'text-gray-100'">{{appBuild === 'INTERNAL' ? 'e-GA' : 'Portal'}} Login</div>
                    <span class="text-xs font-medium tracking-wide" [ngClass]="isLightMode ? 'text-slate-500' : 'text-gray-400'">Enter valid credentials to proceed</span>
                  </div>
                </div>

                <form [formGroup]="form" (ngSubmit)="login(form.value)" class="space-y-5">
                  <!-- Email Field -->
                  <mat-form-field appearance="outline" class="custom-field w-full">
                    <mat-label>Official Email Address</mat-label>
                    <input type="email" matInput formControlName="username">
                    <mat-icon matIconSuffix>email</mat-icon>
                    <mat-error>
                      <span *ngIf="!form.get('username')?.valid && form.get('username')?.touched">
                        Field is required
                      </span>
                    </mat-error>
                  </mat-form-field>

                  <!-- Password Field -->
                  <div class="space-y-1 !mt-0">
                    <div class="flex justify-between items-center px-1 pb-1">
                      <label class="text-[10px] font-bold uppercase tracking-widest text-transparent select-none">&nbsp;</label>
                      <button type="button" (click)="loginStep = 'forgot'; forgotEmail = ''; forgotSuccess = false;" class="text-[10px] font-bold uppercase tracking-widest text-primary-600 dark:text-primary-400 hover:text-primary-800 dark:hover:text-primary-300 transition-colors z-10 relative">
                        Forgot Password?
                      </button>
                    </div>
                    <mat-form-field appearance="outline" class="custom-field w-full -mt-5">
                      <mat-label>Password</mat-label>
                      <input [type]="hide ? 'password' : 'text'" matInput formControlName="password">
                      <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                              [attr.aria-label]="'Hide password'"
                              [attr.aria-pressed]="hide">
                        <mat-icon class="material-icons-outlined">
                          {{ hide ? 'visibility_off' : 'visibility' }}
                        </mat-icon>
                      </button>
                      <mat-error>
                        <span *ngIf="!form.get('password')?.valid && form.get('password')?.touched">
                          Field is required
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Submit Button -->
                  <button
                    type="submit"
                    [disabled]="!form.valid || loading"
                    class="w-full font-bold py-3.5 rounded-xl flex items-center justify-center gap-2 transition-all active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed mt-4 shadow-xl"
                    [ngClass]="isLightMode ? 'bg-primary-600 hover:bg-primary-700 text-white shadow-primary-600/20' : 'bg-teal-600 hover:bg-teal-500 text-white shadow-teal-900/30'">
                    <ng-container *ngIf="!loading">
                  <span>Login</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                      </svg>
                    </ng-container>
                    <div *ngIf="loading" class="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                  </button>
                </form>

              </div>

              <!-- ======= STEP 2: Forgot Password ======= -->
              <div *ngIf="loginStep === 'forgot'" class="animate-fadeIn">
                <!-- Back Button -->
                <button type="button" (click)="loginStep = 'credentials'" aria-label="Go back"
                  class="absolute top-4 right-8 p-2 rounded-full transition-colors text-slate-400 hover:bg-slate-100 dark:hover:bg-gray-700">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>

                <div class="mb-8">
                  <div class="w-14 h-14 bg-gradient-to-br from-primary-50 to-white dark:from-gray-800 dark:to-gray-700 rounded-xl flex items-center justify-center border border-primary-100 dark:border-gray-600 shadow-sm mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-primary-600 dark:text-primary-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>
                  </div>
                  <div class="text-2xl font-bold tracking-tight" [ngClass]="isLightMode ? 'text-slate-900' : 'text-gray-100'">Reset Password</div>
                  <span class="text-xs tracking-wide mt-1 block" [ngClass]="isLightMode ? 'text-slate-500' : 'text-gray-400'">We'll send you instructions to recover your account</span>
                </div>

                <!-- Success Message -->
                <div *ngIf="forgotSuccess" class="text-center animate-fadeIn py-4">
                  <div class="w-16 h-16 rounded-full bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 text-green-500 flex items-center justify-center mx-auto mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </div>
                  <div class="font-bold mb-2" [ngClass]="isLightMode ? 'text-slate-900' : 'text-gray-100'">Check your inbox</div>
                  <p class="text-sm" [ngClass]="isLightMode ? 'text-slate-600' : 'text-gray-300'">
                    A recovery link has been sent to <strong [ngClass]="isLightMode ? 'text-primary' : 'text-teal-400'">{{ forgotEmail }}</strong>
                  </p>
                  <button type="button" (click)="loginStep = 'credentials'"
                    class="mt-8 w-full font-bold py-3.5 rounded-xl transition-all bg-primary-600 hover:bg-primary-700 text-white shadow-lg">
                    Return to Login
                  </button>
                </div>

                <!-- Form -->
                <div *ngIf="!forgotSuccess" class="space-y-5">
                  <mat-form-field appearance="outline" class="custom-field w-full">
                    <mat-label>Official Email</mat-label>
                    <input
                      type="email"
                      matInput
                      [(ngModel)]="forgotEmail"
                      name="forgotEmail"
                    />
                    <mat-icon matIconSuffix>email</mat-icon>
                  </mat-form-field>

                  <button
                    type="button"
                    (click)="sendResetLink()"
                    [disabled]="!forgotEmail || forgotLoading"
                    class="w-full font-bold py-3.5 rounded-xl flex items-center justify-center gap-2 transition-all active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed mt-4 bg-primary-600 hover:bg-primary-700 text-white shadow-xl shadow-primary-600/20">
                    <div *ngIf="forgotLoading" class="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                    <ng-container *ngIf="!forgotLoading">
                      <span>Send Recovery Instructions</span>
                    </ng-container>
                  </button>
                </div>
              </div>

              <!-- ======= STEP 3: MFA (Placeholder) ======= -->
              <div *ngIf="loginStep === 'mfa'" class="text-center animate-fadeIn py-4">
                <div class="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 border transition-colors duration-500 bg-primary-50 border-primary-200 text-primary-600 dark:bg-primary-900/30 dark:border-primary-800 dark:text-primary-400">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4"/><path d="M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2"/><path d="M17.29 21.02c.12-.6.43-2.3.5-3.02"/><path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"/><path d="M8.65 22c.21-.66.45-1.32.57-2"/><path d="M14 13.12c0 2.38 0 6.38-1 8.88"/><path d="M2 16h.01"/><path d="M21.8 16c.2-2 .131-5.354 0-6"/><path d="M9 6.8a6 6 0 0 1 9 5.2v2"/>
                  </svg>
                </div>
                <div class="text-2xl font-bold mb-2" [ngClass]="isLightMode ? 'text-slate-900' : 'text-gray-100'">Secure Verification</div>
                <span class="text-xs mb-8 block" [ngClass]="isLightMode ? 'text-slate-500' : 'text-gray-400'">Enter the 6-digit code sent to your registered device.</span>

                <div class="flex justify-center gap-2 mb-8">
                  <input *ngFor="let i of [1,2,3,4,5,6]" type="text" maxlength="1"
                    class="w-10 h-12 text-center text-lg font-bold rounded-lg outline-none transition-all border bg-slate-50 border-slate-200 text-slate-800 focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:focus:border-primary-400" />
                </div>

                <button (click)="loginStep = 'credentials'"
                  class="w-full font-bold py-3.5 rounded-xl transition-all active:scale-[0.98] mb-4 bg-primary-600 hover:bg-primary-700 text-white shadow-lg">
                  Verify & Proceed
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </main>

  <!-- Footer syncing with layout -->
  <footer class="relative z-10 py-6 px-6 lg:px-12 border-t transition-all duration-500"
          [ngClass]="isLightMode ? 'border-slate-200 bg-white/60 text-slate-500' : 'border-gray-800 bg-gray-900/60 text-gray-400'">
    <div class="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
      <div class="hidden lg:flex items-center gap-6 text-[10px] font-bold uppercase tracking-[0.15em]">
        <span class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors">ISO/IEC 27001:2022 CERTIFIED</span>
        <span class="hover:text-primary-600 dark:hover:text-primary-400 transition-colors">ISO 9001: 2015 CERTIFIED</span>
      </div>
      <div class="flex items-center gap-2">
        <a href="https://www.ega.go.tz/" target="_blank" class="text-[12px] font-bold tracking-widest hover:text-primary-600 dark:hover:text-primary-400 transition-colors">e-Government Authority &copy; 2026</a>
      </div>
    </div>
  </footer>

</div>

<app-accessibility-menu
  [isOpen]="isAccessibilityMenuOpen"
  (closeMenu)="isAccessibilityMenuOpen = false"
></app-accessibility-menu>

<button
  (click)="isAccessibilityMenuOpen = !isAccessibilityMenuOpen"
  class="fixed bottom-8 md:bottom-12 right-8 p-3 rounded-full bg-primary-600 text-white shadow-lg z-[999] opacity-30 hover:opacity-100 hover:scale-110 transition-all animate-fadeIn focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary-500"
  aria-label="Toggle Accessibility Menu"
  [attr.aria-expanded]="isAccessibilityMenuOpen"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="10" r="3"></circle><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path></svg>
</button>
